import React from 'react'
import { Box, Typography, Button, Select, MenuItem, Card, TextField } from '@mui/material'
import { Table, TableContainer, TableHead, TableBody, TableRow, Paper, Checkbox } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'

const ProductList = (props) => {
  const packageData = props.packageData
  const isDisabled = packageData[`${props.packageKey+1}`]['disable-add']
  const currentItems = packageData[`${props.packageKey+1}`]['items']
  let filteredItems = props.filterAllowedItems(props.items, `${props.packageKey+1}`)

  const updateItemWeight = (item, val) => {
    item['weight'] = val
    console.log('weight', item.weight)
  }
  return (
    <TableContainer componenet={Paper}>
      <Table>
        <TableHead>
          <StyledTableCell align="center"></StyledTableCell>
          <StyledTableCell align="center">Product Name</StyledTableCell>
          <StyledTableCell align="center">Weight</StyledTableCell>
          <StyledTableCell align="center">Qty Ordered</StyledTableCell>
          <StyledTableCell align="center">Qty</StyledTableCell>
          {
            isDisabled &&
            <StyledTableCell align="center"></StyledTableCell>
          }
        </TableHead>
        <TableBody>
          {filteredItems.map((item) => {
            const itemcheck = currentItems.includes(item)
            return (
              <StyledTableRow key={item.id}>
                <StyledTableCell component="th" scope="row" align="center">
                  <Checkbox 
                    onChange={(e) => props.itemCheckHandler(e.target.checked, props.packageKey, item)}
                    disabled={isDisabled}
                  />
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ maxWidth: '300px' }}>{item.name}</StyledTableCell>
                <StyledTableCell align="center">
                  <TextField
                    sx={{ width: '100px', height: '40px', borderRadius: 0, border: '1px solid #000' }}
                    variant='outlined'
                    id='length'
                    value={props.itemWeightObj[`${item.mageId}`]}
                    onChange={(e) => props.updateItemWeight(e.target.value, item)}
                  />
                </StyledTableCell>
                <StyledTableCell align="center">{item.quantity}</StyledTableCell>
                <StyledTableCell align="center">{item.quantity}</StyledTableCell>
                {
                  isDisabled && itemcheck &&
                  <StyledTableCell align="center">
                    <Button sx={{ 
                      backgroundColor: '#2b3f7a !important', 
                      color: '#fff !important',
                      textTransform: 'capitalize', 
                      padding: '5px 15px', 
                      color: '#fff', 
                      borderRadius: 0 
                    }}
                    onClick={() => props.removeItemFromPackage(props.packageKey, item)}
                    >
                      Delete
                    </Button>
                </StyledTableCell>
                }
              </StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function CreatePackage(props) {
  const [packageLimit, setPackageLimit] = React.useState(1)
  const [packageRows, setPackageRows] = React.useState(1)
  const [packageData, setPackageData] = React.useState({
    1: {
      'type': null,
      'weight': 0,
      'weight-unit': null,
      'length': null,
      'width': null,
      'height': null,
      'dimension-unit': null,
      'items': [],
      'disable-add': false
    }
  })
  const [packageIndexArray, setPackageIndexArray] = React.useState([])
  const [itemsAlreadySelected, setItemsAlreadySelected] = React.useState([])
  const [itemWeightObj, setItemWeightObj] = React.useState({})

  //setting initial weight of every item as 0.5
  React.useEffect(() => {
    let newItem = {}
    props.items.forEach((item) => {
      newItem[`${item.mageId}`] = 0.5
    })
    setItemWeightObj(newItem)
    console.log('weight obj')
    console.log(itemWeightObj)
  },[])


  const handleAddNewPackage = () => {
    setPackageRows(packageRows + 1)
    const newValues = {
      'type': null,
      'weight': 0,
      'weight-unit': null,
      'length': null,
      'width': null,
      'height': null,
      'dimension-unit': null,
      'items': [],
      'disable-add': false
    }
    let currentPackageData = packageData
    currentPackageData[`${packageRows + 1}`] = newValues
    setPackageData(currentPackageData)
  }

  const packageCreation = (packageKey, itemKey, itemValue) => {
    let currentPackage = packageData
    currentPackage[`${packageKey+1}`][`${itemKey}`] = `${itemValue}`
    setPackageData(currentPackage)
  }

  const createShippingLabel = () => {
    const payloadPackageData = packageData
    props.setPackageDetails && props.setPackageDetails(payloadPackageData)
    props.closePackage && props.closePackage()
  }

  const includeItems = (index) => {
    let current = [...packageIndexArray]
    if (Array.isArray(current)) {
      current.push(index)
    }
    setPackageIndexArray(current)
  }

  const itemCheckHandler = (checkedVal, packageKey, item) => {
    const currentItem = packageData[`${packageKey+1}`]['items']
    let newItem = [...currentItem]
    let newSelected = [...itemsAlreadySelected]
    if (checkedVal) {
      newItem.push(item)
      newSelected.push(item.mageId)
    } else {
      newItem.pop(item)
      newSelected.pop(item.mageId)
    }
    let currentPackage = {...packageData}
    currentPackage[`${packageKey+1}`]['items'] = newItem
    setPackageData(currentPackage)
    setItemsAlreadySelected(newSelected)
  }

  const confirmItems = (packageKey) => {
    let currentPackage = {...packageData}
    currentPackage[`${packageKey+1}`]['disable-add'] = true
    const selectedItems = currentPackage[`${packageKey+1}`]['items']
    let totalWeight = 0
    selectedItems.forEach((item) => {
      totalWeight += Number(itemWeightObj[`${item.mageId}`])
    })
    currentPackage[`${packageKey+1}`]['weight'] = totalWeight
    setPackageData(currentPackage)
  }

  const removeItemFromPackage = (packageKey, item) => {
    const currentPackage = {...packageData}
    const currentItems = currentPackage[`${packageKey+1}`]['items']
    currentItems.pop(item)
    currentPackage[`${packageKey+1}`]['items'] = currentItems
    currentPackage[`${packageKey+1}`]['disable-add'] = false
    setPackageData(currentPackage)
    let indexArray = [...packageIndexArray]
    indexArray.pop(packageKey)
    setPackageIndexArray(indexArray)
  }

  const updateItemWeight = (val, item) => {
    const currentItemWeightObj = {...itemWeightObj}
    currentItemWeightObj[`${item.mageId}`] = val
    setItemWeightObj(currentItemWeightObj)
  }

  const filterAllowedItems = (items = [], packageKey = '1') => {
    let output = [], addedItems = [], itemsHash = []
    Object.entries(packageData).forEach((([key, value]) => {
      if (value['items'].length !== 0)
      {
        addedItems = [...addedItems, (value['items'])]
        itemsHash[`${key}`] = value['items']
      }
    }))
    let modAddedItems = []
    addedItems.forEach((item) => modAddedItems.push(...item))
    if (addedItems.length == 0) {
      output = items
    } else {
      items.forEach((item) => {
        Object.entries(itemsHash).forEach(([key, value]) => {
          if (!value.includes(item) && !output.includes(item) && !modAddedItems.includes(item)) {
            output.push(item)
          } else if (key == packageKey && value.includes(item) && !output.includes(item)) {
            output.push(item)
          }
        })
      })
    }
    return output
  }

  let isAddPackagesDisabled = Object.keys(packageData).length === packageLimit

  return (
    <Box sx={{ width: '90%', height: '90%', backgroundColor: '#fff', margin: '20px 40px 30px', padding: '30px', overflow: 'scroll' }}>
      <Typography sx={{ fontSize: '1.2rem', color: '#000' }}>Create Packages</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: '#2b3f7a !important',
          color: '#fff !important',
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize',
          "&:disabled": {
            opacity: 0.5,
            cursor: 'not-allowed',
            pointerEvents: 'all !important'
          }
        },
        }}
        >
          <Button onClick={() => props.closePackage()}>Cancel</Button>
          <Button onClick={() => handleAddNewPackage()} disabled={isAddPackagesDisabled}>Add Package</Button>
          <Button onClick={() => createShippingLabel()}>Save</Button>
        </Box>
        <Box sx={{ padding: '20px 0px 50px', textAlign: 'center' }}>
          <Typography variant='h6'>Select Total Packages Count:</Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={packageLimit}
            label="Age"
            onChange={(e) => setPackageLimit(e.target.value)}
            sx={{ width: '100px', height: '40px', marginTop: '20px', border: '1px solid #000', borderRadius: 0 }}
          >
            {Array.from({length: props.items.length}, (_, i) => i + 1).map((item) => {
              return (
                <MenuItem value={item}>{item}</MenuItem>
              )
            })}
          </Select>
        </Box>
        {/* List of packages */}
        {[...Array(packageRows)].map((item, idx) => {
          return (
            <Box key={idx} sx={{ width: '100%', height: 'auto', paddingBottom: '50px' }}>
              <Box sx={{ 
                display: 'flex', 
                width: '100%', 
                justifyContent: 'space-between', 
                borderBottom: '2px solid #000', 
                paddingBottom: '10px'
              }}>
                <Typography sx={{ fontSize: '1.2rem', color: '#000' }}>Package {idx+1}</Typography>
                <Button sx={{ 
                  backgroundColor: '#2b3f7a !important',
                  color: '#fff !important',
                  padding: '5px 10px',
                  borderRadius: 0,
                  marginTop: '-20px',
                  textTransform: 'none',
                  "&:disabled": {
                    opacity: 0.5
                  }
                }}
                onClick={packageData[`${idx+1}`]['items'].length > 0 ? () => confirmItems(idx) : () => includeItems(idx)}
                disabled={packageData[`${idx+1}`]['disable-add']}
                >
                  {
                    packageData[`${idx+1}`]['items'].length > 0 ?
                    <Typography>Add Selected Product(s) to Package</Typography> :
                    <Typography>Add Products to Package</Typography>
                  }
                </Button>
              </Box>
              <Card sx={{ 
                border: 'none',
                display: 'inline-flex',
                padding: '20px 0px',
                '& .MuiBox-root': {
                  display: 'block',
                  marginRight: '20px',
                  lineHeight: '60px'
                },
                '& .MuiTypography-root': {
                  fontWeight: 700,
                  color: '#000'
                } 
              }}>
                <Box>
                  <Typography>Type</Typography>
                  <Select
                    sx={{ width: '200px', height: '40px', marginTop: '20px', border: '1px solid #000', borderRadius: 0 }}
                    defaultValue='document'
                    onChange={(e) => packageCreation(idx, 'type', e.target.value)}
                  >
                    <MenuItem value='document'>Documents</MenuItem>
                    <MenuItem value='non-document'>Non-Documents</MenuItem>
                  </Select>
                </Box>
                <Box>
                  <Typography>Total Weight</Typography>
                  <TextField
                    sx={{ width: '200px', height: '40px', marginTop: '18px', borderRadius: 0, border: '1px solid #000' }}
                    variant='outlined'
                    id='weight'
                    disabled={true}
                    value={packageData[`${idx+1}`]['weight']}
                    onChange={(e) => packageCreation(idx, e.target.id, e.target.value)}
                  />
                </Box>
                <Box>
                  <Select
                    sx={{ width: '100px', height: '42px', marginTop: '42px', marginLeft: '-20px', border: '1px solid #000', borderRadius: 0 }}
                    defaultValue='lb'
                    onChange={(e) => packageCreation(idx, 'weight-unit', e.target.value)}
                  >
                    <MenuItem value='lb'>lb</MenuItem>
                    <MenuItem value='kg'>kg</MenuItem>
                  </Select>
                </Box>
                <Box>
                  <Typography>Length</Typography>
                  <TextField
                    sx={{ width: '200px', height: '40px', marginTop: '18px', borderRadius: 0, border: '1px solid #000' }}
                    variant='outlined'
                    id='length'
                    onChange={(e) => packageCreation(idx, e.target.id, e.target.value)}
                  />
                </Box>
                <Box>
                  <Typography>Width</Typography>
                  <TextField
                    sx={{ width: '200px', height: '40px', marginTop: '18px', borderRadius: 0, border: '1px solid #000' }}
                    variant='outlined'
                    id='width'
                    onChange={(e) => packageCreation(idx, e.target.id, e.target.value)}
                  />
                </Box>
                <Box>
                  <Typography>Height</Typography>
                  <TextField
                    sx={{ width: '200px', height: '40px', marginTop: '18px', borderRadius: 0, border: '1px solid #000' }}
                    variant='outlined'
                    id='height'
                    onChange={(e) => packageCreation(idx, e.target.id, e.target.value)}
                  />
                </Box>
                <Box>
                  <Select
                    sx={{ width: '100px', height: '42px', marginTop: '42px', border: '1px solid #000', borderRadius: 0 }}
                    defaultValue='in'
                    onChange={(e) => packageCreation(idx, 'dimension-unit', e.target.value)}
                  >
                    <MenuItem value='in'>in</MenuItem>
                    <MenuItem value='cm'>cm</MenuItem>
                  </Select>
                </Box>
              </Card>
              {
                packageIndexArray.includes(idx) === true ?
                <Card>
                  <ProductList 
                    items={props.items ? props.items : []} 
                    packageKey={idx} 
                    packageData={packageData}
                    itemCheckHandler={itemCheckHandler}
                    removeItemFromPackage={removeItemFromPackage} 
                    updateItemWeight={updateItemWeight}
                    itemsAlreadySelected={itemsAlreadySelected}
                    filterAllowedItems={filterAllowedItems}
                    itemWeightObj={itemWeightObj}
                  />
                </Card> : null
              }
            </Box>
          )
        })}
        <Box>
      </Box>
    </Box>
  )
}

export default CreatePackage